import { FILTER_TYPES } from "components/UI/Table/constants/filter.ts";
import { EntityColumnOptions, entityColumn } from "components/UI/Table/columns/entity/entityColumn.tsx";
import { TableColumnType } from "components/UI/Table/types/table.ts";
import { EntityLinkCell } from "components/UI/Table/UI/EntityLinkCell/EntityLinkCell.tsx";

import OfferData = App.Data.OfferData;
import OfferDataOptional = App.Data.OfferDataOptional;

export const OfferColumn = <T,>(
    options: EntityColumnOptions<T, OfferData | OfferDataOptional>
): TableColumnType<T> =>
    entityColumn<T, OfferData | OfferDataOptional>(
        {
            dataIndex: "offer.title",
            key: "offer.title",
            sorter: true,
            filterable: true,
            filterType: FILTER_TYPES.offerSelect,
            filterName: "offer_id",
            sortName: "offer.title",
            ellipsis: true,
        },
        (entity) => <EntityLinkCell.Offer entity={entity} />,
        options
    );
